<div class="tabs-container">
  <div class="tabs-header">
    @for (tab of tabs; track tab.title()) {
    <button
      class="tab-button"
      [class.active]="tab.active()"
      (click)="selectTab(tab)"
      id="{{ tab.id() }}"
    >
      {{ tab.title() }}
    </button>
    }
  </div>
  <div class="tabs-content">
    <ng-content />
  </div>
</div>
